import { api } from './palmPayApi';
import type { Transaction } from '../types';

// Transaction API
export const getTransactionHistory = async (userId: string): Promise<{ transactions: Transaction[] }> => {
  const response = await api.get<{ transactions: Transaction[] }>('/transaction/history', { params: { userId } });
  return response.data;
};

export const getAllTransactions = async (): Promise<any> => {
  const response = await api.get('/transaction');
  return response.data;
};

export const deleteTransaction = async (txid: number): Promise<any> => {
  const response = await api.delete(`/transaction/${txid}`);
  return response.data;
};

